import React, { useState } from "react";
import AppLayout from "@/Layouts/AppLayout";
import { useTitle } from "@/Utilities/Hooks";
import OrganizationLayout from "@/Layouts/OrganizationLayout";
import LayoutIcon from "@/Components/LayoutIcon";
import { Users } from "@/Icons";
import { Tab, Tabs } from "@/Components/Tabs";
import GlobalReporterUserRow from "@/Pages/Agency/Users/Partials/GlobalReportUserRow";
import { Dialog } from "@/Components";
import { LabeledInput } from "@/Components/Form";
import { Inertia } from "@inertiajs/inertia";
import { usePage } from "@inertiajs/inertia-react";
import { toast } from "react-toastify";

export default function ManageUsers({ users }) {
  useTitle("Manage users");

  return (
    <Tabs items={["Global reporters"]}>
      <Tab>
        {users?.data?.map((user) => (
          <GlobalReporterUserRow key={user.id} user={user} />
        ))}
      </Tab>
    </Tabs>
  );
}

const HeaderActions = () => {
  const errors = usePage().props?.errors || {};
  const organization = usePage().props?.organization?.data || {};

  const [showDialog, setShowDialog] = useState(false);
  const [emails, setEmails] = useState("");

  const handleSubmit = (e) => {
    e.preventDefault();

    const id = toast.loading("Please wait...");

    Inertia.post(
      route("agency.users.invite"),
      {
        emails: emails.split(","),
      },
      {
        onSuccess: () => {
          toast.update(id, {
            render: "User was successfully added",
            type: "success",
            isLoading: false,
            autoClose: 5000,
          });
          setEmails("");
          setShowDialog(false);
        },
        onError: (error) => {
          toast.update(id, {
            render: "Something went wrong when adding user",
            type: "error",
            isLoading: false,
            autoClose: 5000,
          });
        },
      },
    );
  };

  return (
    <>
      <button
        className="btn-blue shrink-0 grow-0"
        onClick={() => setShowDialog(true)}
      >
        Add user
      </button>

      {showDialog && (
        <Dialog
          openModal={showDialog}
          closeModal={() => setShowDialog(false)}
          modalStyle="popup"
          animation="fade-in"
          title="You're about to add a global reporter to your organization"
          tag="Add global reporter"
          tagStyle="bg-primary text-white"
        >
          <p className="-mt-4">
            Global reporters can access all clients, activities and emission
            factors within your organization.
            <br />
            This will add another{" "}
            {organization.billing.pricing.global_reporter_price || "-"} kr/month
            to your monthly invoice.
          </p>

          <form onSubmit={handleSubmit} className="flex flex-col gap-8">
            <LabeledInput
              title="E-mail"
              placeholder="Enter e-mail"
              className="w-full"
              value={emails}
              onChange={(e) => setEmails(e.target.value)}
              error={errors?.emails}
            />

            <div className="flex w-full items-center justify-end">
              <a
                className="cursor-pointer text-blue underline"
                onClick={() => setShowDialog(false)}
              >
                Never mind
              </a>

              <button className="btn ml-3 self-end" disabled={emails === ""}>
                Add global reporter
              </button>
            </div>
          </form>
        </Dialog>
      )}
    </>
  );
};

ManageUsers.layout = (page) => {
  return (
    <AppLayout>
      <OrganizationLayout
        header="Manage users"
        icon={
          <LayoutIcon>
            <Users size={40} className="text-black" />
          </LayoutIcon>
        }
        action={<HeaderActions />}
        byline="Manage your global reporters that can access this organzations, it's clients and activities."
      >
        {page}
      </OrganizationLayout>
    </AppLayout>
  );
};
